import { render, staticRenderFns } from "./MWrapperFolder2.vue?vue&type=template&id=3bedd7fd&scoped=true"
import script from "./MWrapperFolder2.vue?vue&type=script&lang=js"
export * from "./MWrapperFolder2.vue?vue&type=script&lang=js"
import style0 from "./MWrapperFolder2.vue?vue&type=style&index=0&id=3bedd7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bedd7fd",
  null
  
)

export default component.exports